import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { PageHeader, Toast } from "@/components/Layout";
import api from "@/lib/api";

const errText = (e) => e?.response?.data?.detail || "Eroare";
export const STAGE_BADGE = { draft: "badge-draft", submitted: "badge-submitted", dept_council: "badge-submitted", faculty_council: "badge-submitted", admin_council: "badge-submitted", senate: "badge-approved" };

/** Statele de funcții didactice pe departament: lista departamentelor unui an universitar, cu starea și piedicile de trimitere. */
export default function StaffDepartments() {
  const [params, setParams] = useSearchParams();
  const [years, setYears] = useState(null);
  const [data, setData] = useState(null);
  const [msg, setMsg] = useState({ text: "", type: "info" });
  const yearId = params.get("year") || (years && (years.find(y => y.is_current) || years[0] || {}).id) || "";

  useEffect(() => { api.get("/stat-didactic/years").then(r => setYears(r.data)).catch(() => setYears([])); }, []);
  useEffect(() => {
    if (!yearId) return;
    setData(null);
    api.get("/stat-didactic/staff/departments", { params: { year_id: yearId } }).then(r => setData(r.data))
      .catch(e => { setData({ departments: [], error: errText(e) }); setMsg({ text: errText(e), type: "error" }); });
  }, [yearId]);

  if (years === null) return <div>Se încarcă...</div>;
  if (years.length === 0) return <div className="card" style={{ padding: 24 }}>Nu există niciun an universitar. Creează-l din <Link to="/stat-didactic/ani">Ani universitari</Link>.</div>;
  return (
    <>
      <PageHeader title="Statul de funcții didactic pe departament" subtitle="Orele comandate fiecărui departament, repartizate nominal pe cadre didactice și posturi vacante" />
      <Toast msg={msg.text} type={msg.type} />
      <div style={{ marginBottom: 14, maxWidth: 260 }}>
        <label className="label">An universitar</label>
        <select className="select" value={yearId} onChange={e => setParams({ year: e.target.value })} data-testid="sfd-staff-year">
          {years.map(y => <option key={y.id} value={y.id}>{y.name}</option>)}</select>
      </div>
      {!data ? <div>Se încarcă...</div> : data.error ? (
        <div className="card" style={{ padding: 24 }} data-testid="sfd-staff-error">{data.error} <Link to="/stat-didactic/setari">Deschide Setările</Link></div>
      ) : data.departments.length === 0 ? <div className="card" style={{ padding: 24, color: "#64748B" }}>Nu există departamente la nivelul ales în Setări.</div> : (
        <div className="card">
          <table className="tbl" data-testid="sfd-staff-departments">
            <thead><tr><th>Departament</th><th>Stare</th><th className="tabular-nums">Titulari</th><th className="tabular-nums">Posturi vacante</th><th className="tabular-nums">Ore comandate (formații)</th><th className="tabular-nums">Neacoperite</th><th>Piedici de trimitere</th><th></th></tr></thead>
            <tbody>{data.departments.map(d => (
              <tr key={d.id} data-testid={`sfd-staff-dept-${d.name}`}>
                <td style={{ fontWeight: 600 }}>{d.path}</td>
                <td><span className={"badge " + (STAGE_BADGE[d.stage] || "badge-draft")}>{d.stage_label}</span></td>
                <td className="tabular-nums">{d.holders}</td><td className="tabular-nums">{d.vacant_posts}</td>
                <td className="tabular-nums">{d.rows}</td>
                <td className="tabular-nums" style={{ color: d.uncovered ? "#B91C1C" : undefined, fontWeight: d.uncovered ? 700 : 400 }}>{d.uncovered}</td>
                <td className="tabular-nums">{d.blockers || "—"}</td>
                <td><Link className="btn btn-secondary" style={{ padding: "3px 10px", fontSize: 12 }} to={`/stat-didactic/stat/${d.id}?year=${yearId}`} data-testid={`sfd-staff-open-${d.name}`}>Deschide</Link></td>
              </tr>))}</tbody>
          </table>
        </div>)}
    </>
  );
}
